import styled from 'styled-components';
import { colors } from '../styles/colors';

export default styled.h1`
  font-size: 1.7em;
  font-weight: bold;
  color: ${colors.text};
  margin-bottom: 1rem;
  margin-top: 1rem;
`;
